<template>
	<v-row justify="center">
		<v-col cols="12">
			<div class="d-flex justify-space-between py-4">
				<div class="d-flex cursor-pointer" @click="$router.go(-1)">
					<v-icon>mdi-chevron-left</v-icon>
					<div class="ml-2">Back</div>
				</div>
				<div>
					<span>Already have an account?</span>
					<span
						class="text-decoration-underline secondary--text ml-2 cursor-pointer"
						@click="goToPage('auth.login')"
						>Login</span
					>
				</div>
			</div>
		</v-col>
		<v-col cols="11" md="8" lg="10" xl="10">
			<p class="text-h4 font-weight-bold">
				Register Individual
				<span class="secondary--text text-h4 font-weight-bold homify-title"
					>Homify</span
				>
				Account!
			</p>
			<p class="mb-6">
				For the purpose of industry regulation, your details are required.
			</p>
			<v-divider />

			<v-row class="mt-10">
				<v-col cols="12" v-if="referredBy">
					<v-alert color="secondary" outlined>
						<div class="text-center">
							You were referred by: {{ referredBy }}
						</div>
					</v-alert>
				</v-col>
				<v-col cols="12" md="6">
					<div class="mb-2">Your First Name*</div>
					<v-text-field
						:rules="[rules.required]"
						v-model="registrationForm.firstName"
						placeholder="Enter first name"
						outlined
					></v-text-field>
				</v-col>
				<v-col cols="12" md="6">
					<div class="mb-2">Your Middle Name</div>
					<v-text-field
						v-model="registrationForm.middleName"
						placeholder="Enter middle name"
						outlined
					></v-text-field>
				</v-col>
				<v-col cols="12" md="6">
					<div class="mb-2">Your Last Name*</div>
					<v-text-field
						:rules="[rules.required]"
						v-model="registrationForm.lastName"
						placeholder="Enter last name"
						outlined
					></v-text-field>
				</v-col>
				<v-col cols="12" md="6">
					<div class="mb-2">Email Address*</div>
					<v-text-field
						:rules="[rules.required, rules.email]"
						v-model="registrationForm.email"
						placeholder="Enter email Address"
						outlined
					></v-text-field>
				</v-col>
				<v-col cols="12" md="6">
					<div class="mb-2">Phone Number*</div>
					<v-text-field
						:rules="[rules.required]"
						v-model="registrationForm.phoneNumber"
						placeholder="Enter phone number"
						outlined
					></v-text-field>
				</v-col>
				<v-col cols="12" md="6">
					<div class="mb-2">Referrer's Code/Number</div>
					<v-text-field
						v-model="registrationForm.referralCode"
						placeholder="Enter referrer's code or phone number"
						outlined
						:loading="isRunning"
						color="primary"
						persistent-hint
						:hint="referredBy ? `You were referred by: ${referredBy}` : ''"
					>
						<template v-slot:progress>
							<v-progress-linear
								color="secondary"
								absolute
								indeterminate
								height="3"
							></v-progress-linear>
						</template>
					</v-text-field>
				</v-col>
				<v-col cols="12" md="12" class="mb-0 pb-0">
					<div class="mb-2">Create Password*</div>
					<v-text-field
						@click:append="isPasswordVisible = !isPasswordVisible"
						:append-icon="isPasswordVisible ? 'mdi-eye-off' : 'mdi-eye'"
						:rules="[rules.required, rules.minPassword]"
						v-model="registrationForm.password"
						placeholder="Enter password"
						:type="isPasswordVisible ? 'text' : 'password'"
						outlined
					></v-text-field>
				</v-col>
				<v-col class="mt-0 pt-0">
					<small class="primary--text"
						>Required Fields are indicated with *</small
					>
					<v-checkbox
						class="mt-2 py-0"
						color="info"
						v-model="registrationForm.tcAgreement"
						label
					>
						<template v-slot:label>
							<div>
								I agree to the
								<span
									color="primary"
									class="text-none secondary--text"
									@click="tcDialog = true"
									>Terms & Conditions</span
								>
								<v-dialog v-model="tcDialog" width="600px" persistent>
									<v-card>
										<v-card-title>
											<span class="headline">Homify Terms & Conditions</span>
										</v-card-title>
										<v-card-text>
											<terms />
										</v-card-text>
										<v-card-actions>
											<v-spacer></v-spacer>
											<v-btn
												color="error"
												text
												@click="
													tcDialog = false;
													registrationForm.tcAgreement = false;
												"
												>Disagree</v-btn
											>
											<v-btn
												color="green darken-1"
												text
												@click="
													tcDialog = false;
													registrationForm.tcAgreement = true;
												"
												>Agree</v-btn
											>
										</v-card-actions>
									</v-card>
								</v-dialog>
							</div>
						</template>
					</v-checkbox>
				</v-col>
			</v-row>

			<v-btn
				:loading="isSending"
				:disabled="!rulesSatisfied"
				@click="handleRegister"
				block
				depressed
				color="primary"
				class="py-7 mt-10 text-none white--text"
				>Register Account</v-btn
			>
		</v-col>
	</v-row>
</template>

<script>
	import { mapActions } from "vuex";
	import Terms from "@/components/Terms";
	// import pgUtilsMixin from "./../../mixins/pgUtilsMixin.js";

	export default {
		components: {
			Terms,
		},
		data() {
			return {
				tcDialog: false,
				isSending: false,
				isPasswordVisible: false,
				isRunning: false,
				registrationForm: {
					tcAgreement: false,
					firstName: "",
					middleName: "",
					lastName: "",
					email: "",
					phoneNumber: "",
					password: "",
					referralCode: "",
				},
				referredBy: "",
				rules: {
					required: (value) => !!value || "Required.",
					counter: (value) => value.length <= 20 || "Max 20 characters",
					minPassword: (value) => value.length > 8 || "Min 9 characters",
					email: (value) => {
						const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
						return pattern.test(value) || "Invalid e-mail.";
					},
				},
			};
		},
		// mixins: [pgUtilsMixin],
		computed: {
			rulesSatisfied() {
				return (
					this.registrationForm.firstName &&
					this.registrationForm.lastName &&
					this.registrationForm.email &&
					this.registrationForm.phoneNumber.length > 8 &&
					this.registrationForm.password &&
					this.registrationForm.tcAgreement
				);
			},
			referralCode() {
				return this.registrationForm.referralCode;
			},
		},
		methods: {
			...mapActions("auth", ["register", "resolveReferrer"]),
			goToPage(name) {
				this.$router.push({ name });
			},
			async handleRegister() {
				this.isSending = true;

				let body = {
					firstname: this.registrationForm.firstName,
					lastname: this.registrationForm.lastName,
					phonenumber: this.registrationForm.phoneNumber,
					email: this.registrationForm.email.replace(/\s/g, ""),
					password: this.registrationForm.password,
					referrerscode: this.registrationForm.referralCode,
					middlename: this.registrationForm.middleName,
				};

				try {
					await this.register(body);

					this.isSending = false;

					this.$router.replace({
						name: "auth.verify-email",
						query: { email: this.registrationForm.email },
					});
				} catch (error) {
					this.isSending = false;
					// throw error;
				}
			},
			async handleResolve(referral) {
				// this.referredBy = "";
				this.isRunning = true;

				if (referral.length > 5 && referral.length < 16) {
					let { name } = await this.resolveReferrer(referral);
					if (name) this.referredBy = name;
					// console.log(name);
				}
				this.isRunning = false;
			},
		},
		watch: {
			referralCode(val) {
				this.handleResolve(val);
			},
		},
		mounted() {
			let referrerscode = this.$route.params.referrerscode;
			if (referrerscode) {
				this.registrationForm.referralCode = referrerscode;
			}

			window.fbq("trackCustom", "signupPage");
			this.$ua.trackView("signupPage");
			// this.resolveReferrer = this.inputDebounce(this.resolveReferrer, 1000);
		},
	};
</script>
